<template lang="pug">
  v-textarea(
    :value="value",
    :rules="required ? [v => !!v || this.$attrs.label + ' is required'] : []",
    v-bind="$attrs",
    @input="$emit('update:value', $event)",
  )
</template>

<script>
export default {
  props: {
    value: {
      validator: prop => ['string', 'undefined'].includes(typeof prop),
      required: true,
    },

    required: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
